import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import {getToken} from '../util/auth'
// import * as process from "../../frontend2/static/js/echarts";

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: '主页',
            requiresAuth: true
        }
    },
    {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "about" */ '../views/login.vue'),
        meta: {
            title: '登录',
            requiresAuth: false
        }
    },
    {
        path: '/hkv',
        name: 'hkv',
        component: () => import(/* webpackChunkName: "about" */ '../views/hkv2.vue'),
        meta: {
            title: '监控',
            requiresAuth: true
        }
    },
    {
        path: '/onlineSearch',
        name: 'onlineSearch',
        component: () => import(/* webpackChunkName: "about" */ '../views/onlineSearch.vue'),
        meta: {
            title: '在线查询',
            requiresAuth: true
        }
    },
    {
        path: '/warningSearch',
        name: 'warningSearch',
        component: () => import(/* webpackChunkName: "about" */ '../views/warningSearch.vue'),
        meta: {
            title: '报警记录',
            requiresAuth: true
        }
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

/**
 * 允许访问的URL
 * @param url
 */
function checkAlwaysAllowedUrls(url) {
    return (
        url.includes('/login')
    )
}

// // 全局的 before 钩子
// router.beforeEach((to, from, next) => {
//
//
//   function isAuth() {
//     if (to.meta) {
//       return true;
//     }
//     return to.matched.some(record => record.meta.requiresAuth);
//   }
//   // console.log(to.meta,!isAuth())
//     (async function () {
//       if (!isAuth()) {
//         next()
//       }else{
//         if (getToken('token')) {
//           console.log('有token进来了',getToken('token'))
//           next()
//         } else{
//           console.log('没有token进来了',getToken('token'))
//           next({
//             path: '/login',
//           })
//
//         }
//       }
//
//
//
//
//     })()
//
// });

router.beforeEach((to, from, next) => {
  console.log(1)
  if (to.matched.some(res => res.meta.requiresAuth)) {// 判断是否需要登录权限
    console.log(2)
    if (getToken('token')) {// 判断是否登录
      console.log(3)
      next()
    } else {// 没登录则跳转到登录界面
      console.log(4)
        // next()
      next({
        path: '/login',
      })
    }
  } else {
    console.log(5)
    next()
  }
})


export default router
